import { FieldValues } from 'react-hook-form';
import { useModalsContext } from '../../../../contexts';
import { useUpdateAccount } from '../../../../hooks';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { ClearableConnectedInputField } from '../../Shared/ClearableConnectedInputField';
import { CustomHeadersFields } from '../../Shared/CustomHeadersFields';
import { OAuthGroupGrid, UnspacedSubtitle2 } from './CustomEmail.styled';
import { EditModalRHF } from '../../Shared/EditModalRHF';
import { createEditCustomEmailAccountPayload } from './CustomEmail.utils';

const {
  NAME,
  API_ENDPOINT,
  CLIENT_ID,
  CLIENT_SECRET,
  TOKEN_ENDPOINT,
  EDIT_CLIENT_SECRET,
  CUSTOM_HEADERS,
} = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const CustomEmailEditModal = () => {
  const { hideModal } = useModalsContext();

  const { updateAccount } = useUpdateAccount();

  const onSubmit = (values: FieldValues) => {
    const payload = createEditCustomEmailAccountPayload(values);
    updateAccount(payload);
    hideModal();
  };

  return (
    <EditModalRHF onSubmit={onSubmit}>
      <ConnectedInputField name={NAME} labelText="Name" />
      <ConnectedInputField
        name={API_ENDPOINT}
        labelText="Endpoint"
        placeholder="Example: https://www.endpointurl.com"
      />
      <UnspacedSubtitle2>OAuth 2.0</UnspacedSubtitle2>
      <OAuthGroupGrid>
        <ConnectedInputField name={CLIENT_ID} labelText="Client ID" />
        <ClearableConnectedInputField
          name={CLIENT_SECRET}
          labelText="Client secret"
          wasEditedFieldName={EDIT_CLIENT_SECRET}
        />
      </OAuthGroupGrid>
      <ConnectedInputField
        name={TOKEN_ENDPOINT}
        labelText="Token URL"
        placeholder="Example: https://www.endpointurl.com"
      />
      <CustomHeadersFields name={CUSTOM_HEADERS} />
    </EditModalRHF>
  );
};
